(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteTranslationDeleteController',PublicSiteTranslationDeleteController);

    PublicSiteTranslationDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSiteTranslation'];

    function PublicSiteTranslationDeleteController($uibModalInstance, entity, PublicSiteTranslation) {
        var vm = this;

        vm.publicSiteTranslation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSiteTranslation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
